/**
 * Determines the radian angle from the center to a given position,
 * normalized to a [0, 2π) range.
 *
 * @param {Object} center the center position, including x and y
 * @param {Object} position the current position, including x and y
 * @returns {number} the angle in radians, in the range [0, 2π)
 */
export const getRadsFromCenter = (center, position) => {
  if (!center || !position) {
    return 0;
  }

  const { x: centerX = 0, y: centerY = 0 } = center;
  const { x: posX = 0, y: posY = 0 } = position;

  const angle = Math.atan2(posY - centerY, posX - centerX);

  // Normalize from (-π, π] to [0, 2π)
  return (angle + 2 * Math.PI) % (2 * Math.PI);
};
